import React, { useState, useEffect } from "react";
import { Flex, Box, TextInput, Button, Text } from "@mantine/core";
import axios from "axios";
import toast from "react-hot-toast";
import { Scanner } from "@yudiel/react-qr-scanner";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export default function DealerVerification({
  setDealerCodeData,
  codeVerificationData,
  size = 250,
}) {
  const { t } = useTranslation();
  const [codeValue, setCodeValue] = useState("");
  const [error, setError] = useState(null);
  const [triedAgain, setTriedAgain] = useState(false);

  function onCodeSubmit(scannedCodeValue) {
    const req = {
      ...codeVerificationData,
      code: scannedCodeValue || codeValue,
    };

    axios
      .post(`/ride-challenge/verification-code-check/`, req)
      .then(({ data }) => {
        setDealerCodeData(data.response[0]);
      })
      .catch((err) => {
        setCodeValue("");
        toast.error(err, {
          duration: 10000,
        });
      });
  }

  return (
    <div>
      <Text c="white" align="center" mb="xl" fw={600}>
        {t("microsite:dealer_verification_title")}
      </Text>
      <Flex justify="center" mb="xl">
        {error ? (
          <div>
            <Text size="lg" c="red" align="center" fw={600}>
              {t("microsite:dealer_verification_error_message")}
            </Text>
            <Box mt="lg">
              {!triedAgain && (
                <Button
                  fullWidth
                  onClick={() => {
                    setError(null);
                    setTriedAgain(true);
                  }}
                  size="lg"
                  mt="lg"
                  mb="sm"
                >
                  {t("microsite:dealer_verification_try_again")}
                </Button>
              )}
              {triedAgain && (
                <Text mb="lg" size="lg" c="red" align="center" fw={600}>
                  {t("microsite:dealer_verification_tried_again_error_message")}
                </Text>
              )}
              <Button
                fullWidth
                size="lg"
                onClick={() => window.location.reload()}
              >
                {t("microsite:dealer_verification_reload_page")}
              </Button>
            </Box>
          </div>
        ) : (
          <StyledScanner size={size}>
            <Scanner
              styles={{
                container: {},
              }}
              onScan={(result) => {
                if (result.length && result[0].rawValue) {
                  // setCodeValue(result[0].rawValue);
                  onCodeSubmit(result[0].rawValue);
                }
              }}
              onError={(e) => {
                setError(e);
              }}
            />
          </StyledScanner>
        )}
      </Flex>
      {["dev", "qa"].includes(import.meta.env.VITE_ENV) && (
        <>
          <TextInput
            label={t("microsite:dealer_code_input_label")}
            value={codeValue}
            onChange={(e) => setCodeValue(e.target.value)}
          />
          <Button
            mt="xs"
            fullWidth
            disabled={!codeValue}
            onClick={() => onCodeSubmit()}
          >
            {t("common:submit")}
          </Button>
        </>
      )}
    </div>
  );
}

const StyledScanner = styled.div`
  display: flex;
  justify-content: center;
  height: ${(props) => (props.size ? `${props.size}px` : "250px")};
  width: ${(props) => (props.size ? `${props.size}px` : "250px")};

  svg {
    border: none !important;
  }
`;
